import { render, staticRenderFns } from "./Request.vue?vue&type=template&id=38d78ade&scoped=true"
import script from "./Request.vue?vue&type=script&lang=js"
export * from "./Request.vue?vue&type=script&lang=js"
import style0 from "./Request.vue?vue&type=style&index=0&id=38d78ade&prod&scoped=true&lang=css"
import style1 from "./Request.vue?vue&type=style&index=1&id=38d78ade&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d78ade",
  null
  
)

export default component.exports